import { render, staticRenderFns } from "./SLItemEmail2.vue?vue&type=template&id=99324eb2&"
import script from "./SLItemEmail2.vue?vue&type=script&lang=js&"
export * from "./SLItemEmail2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports